// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__2rG-r","main":"Footer_main__1l7I7","names":"Footer_names__3Ib0-","commentMessage":"Footer_commentMessage__3kubv","email":"Footer_email__2GJZb"};